import { IntlFormatters } from "react-intl";
import defineMessages from "../defineMessages";

const clefMessages = defineMessages({
    treble: {
        id: "clef.treble",
    },
    trebleOctave: {
        id: "clef.treble.octaveDown",
    },
    bass: {
        id: "clef.bass",
    },
    doClef: {
        id: "clef.do",
    },
    alternating: {
        id: "meta.alternating",
    },
    stick: {
        id: "score.stick",
    },
});

export const clefs = (fn: IntlFormatters["formatMessage"]) => {
    return [
        { value: "treble", label: fn(clefMessages.treble) },
        { value: "treble-octave", label: fn(clefMessages.trebleOctave) },
        { value: "bass", label: fn(clefMessages.bass) },
        { value: "do", label: fn(clefMessages.doClef) },
        { value: "alternating", label: fn(clefMessages.alternating) },
        { value: "stick", label: fn(clefMessages.stick) },
    ];
};